import React, { useCallback } from 'react';
import { StackModalActionType, StackModalAction } from '../../types';

export const useFieldActions = (dispatch: React.Dispatch<StackModalAction>) => {
  const handleFieldChange = useCallback(
    (
      controlModeIndex: number,
      sectionIndex: number,
      fieldIndex: number,
      newValue: string | number | boolean | null,
    ) => {
      dispatch({
        type: StackModalActionType.UPDATE_FIELD_VALUE,
        payload: { controlModeIndex, sectionIndex, fieldIndex, newValue },
      });
    },
    [dispatch],
  );

  const handleDeleteSection = useCallback(
    (controlModeIndex: number, sectionIndex: number) => {
      dispatch({
        type: StackModalActionType.DELETE_SECTION,
        payload: { controlModeIndex, sectionIndex },
      });
    },
    [dispatch],
  );

  return {
    handleFieldChange,
    handleDeleteSection,
  };
};
